// extracted by mini-css-extract-plugin
export default {"iconHeader":"ModalPropostaIndicador_iconHeader__yN5bs"};